import React from 'react';
interface CornerBracketsProps {
  className?: string;
  color?: 'cyan' | 'magenta';
}
export function CornerBrackets({
  className = '',
  color = 'cyan'
}: CornerBracketsProps) {
  const borderColor = color === 'cyan' ? 'border-cyan' : 'border-magenta';
  return <div className={`absolute inset-0 pointer-events-none ${className}`} data-id="element-103">
      {/* Top Left */}
      <div className={`absolute top-0 left-0 w-4 h-4 border-t-2 border-l-2 ${borderColor}`} data-id="element-104" />

      {/* Top Right */}
      <div className={`absolute top-0 right-0 w-4 h-4 border-t-2 border-r-2 ${borderColor}`} data-id="element-105" />

      {/* Bottom Left */}
      <div className={`absolute bottom-0 left-0 w-4 h-4 border-b-2 border-l-2 ${borderColor}`} data-id="element-106" />

      {/* Bottom Right */}
      <div className={`absolute bottom-0 right-0 w-4 h-4 border-b-2 border-r-2 ${borderColor}`} data-id="element-107" />
    </div>;
}